import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import FontFamily from "./textEditors/fontFamily";
import "./textEditor.css";
import FontSize from "./textEditors/fontSize";
import FontStyles from "./textEditors/fontStyles";
import ColorEditor from "./colorEditor/colorEditor";
import ResetCanvas from "./resetCanvas";
import Upload from "./buttons/upload";
import useWindowDimensions from "../../../hooks/useWindowDimensions";
import FromUrlBtn from "./buttons/fromUrl";

//will contain elements which allows the user to modify the text in the activity he is creating
export default function TextEditor() {
  const { selectedUserActivity, selectedComponent, userActivities, videoVisible, isVideo } = useSelector((state) => state.userActivity);
  const { activityTypes } = useSelector((state) => state.activityTypes);

  const [isSubtypeBackground, setIsSubtypeBackground] = useState(false);
  const { selectedCategoryName } = useSelector((state) => state.activityCategories);

  const { width } = useWindowDimensions();
  const [colorEditorPos, setColorEditorPos] = useState({});
  const colorRef = useRef(null);

  useEffect(() => {
    let subtypeName = "";
    let selectedActivity = userActivities[selectedUserActivity];
    activityTypes.map((type) => {
      type.subtypes.forEach((subtype) => {
        if (subtype.id === selectedActivity?.activity_subtype_id) {
          subtypeName = subtype.name;
        }
      });
    });
    let bgRegex = new RegExp(/background/i);
    if (bgRegex.test(subtypeName)) {
      setIsSubtypeBackground(true);
    } else {
      setIsSubtypeBackground(false);
    }
  }, [userActivities[selectedUserActivity]]);

  useEffect(() => {
    setPosition();
  }, [width, selectedComponent]);

  // console.log(colorEditorPos)

  useEffect(() => {
    if (!colorRef.current) return;
    colorRef.current.addEventListener("scroll", setPosition);
    return () => {
      if (!colorRef.current) return;
      colorRef.current.removeEventListener("scroll", setPosition);
    };
  }, [colorRef, width]);

  const setPosition = () => {
    if (width <= 1275) {
      if (colorRef.current === null) return;
      let pos = colorRef.current.getBoundingClientRect();
      let x = pos.left;
      if (pos.left < 220) {
        x = 220;
      } else {
        x = x + 50;
      }
      setColorEditorPos({
        x: x,
        y: pos.top,
      });
    }
  };
  let selectedActivity = userActivities[selectedUserActivity];

  // console.log('selectedActivity', selectedActivity)
  let objLength = 1
  if (selectedActivity !== undefined) {
    objLength = Object.keys(selectedActivity).length
  }

  // console.log(colorEditorPos)
  if (selectedCategoryName === 'Video Activity' && userActivities.length < 1 || videoVisible) {
    return (
      <section className="activity_container__text_editor_main">
        <div className="activity_container__text_editor" onScroll={setPosition}>
          <p className="text">Video :</p>
          <Upload video={true} />
          <FromUrlBtn />
        </div>
      </section>
    )
  }

  if (objLength < 3) {
    return (
      <section className="activity_container__text_editor_main">
        <div className="activity_container__text_editor" onScroll={setPosition} style={{ height: '40px' }} >
        </div>
      </section>
    )
  }
  return (
    <section className="activity_container__text_editor_main">
      <div className="activity_container__text_editor" onScroll={setPosition}>
        {selectedComponent.type === "text" && (
          <>
            <p className="text">Text :</p>
            <FontFamily />
            <FontSize />
            <FontStyles />
            <ColorEditor
              colorEditorPos={colorEditorPos}
              width={width}
              colorRef={colorRef}
            />
            <ResetCanvas />
          </>
        )}
        {selectedComponent.type === "image" && (
          <>
            <p className="text">Image :</p>
            <Upload />
            <ResetCanvas />
          </>
        )}
        {selectedComponent.type === "button" && (
          <>
            <p className="text text-button">Button :</p>
            <ColorEditor
              colorEditorPos={colorEditorPos}
              width={width}
              colorRef={colorRef}
              hideIcon={true}
            />
            <p className="text text-button">Button hover :</p>
            <ColorEditor
              colorEditorPos={colorEditorPos}
              width={width}
              colorRef={colorRef}
              hover={true}
              hideIcon={true}
            />
            <ResetCanvas />
          </>
        )}
        {selectedComponent.type === "slide" && (
          <>
            <p className="text">Slide :</p>
            {isSubtypeBackground ? (
              <Upload />
            ) : (
              <ColorEditor
                colorEditorPos={colorEditorPos}
                width={width}
                colorRef={colorRef}
              />
            )}
            <ResetCanvas />
          </>
        )}
        {selectedComponent.type === "crossword_grid" && (
          <>
            <p className="text">Grid :</p>
            <p className="text">Background</p>
            <ColorEditor
              colorEditorPos={colorEditorPos}
              width={width}
              colorRef={colorRef}
              gridBackground
            />
            <p className="text">Text</p>
            <FontFamily />
            <ColorEditor
              colorEditorPos={colorEditorPos}
              width={width}
              colorRef={colorRef}
              gridText
            />
            <ResetCanvas />
          </>
        )}
      </div>
    </section>
  );
}
